
export const MEDIA_STATE = {
    NONE: 0,
    STARTING: 1,
    RUNNING: 2,
    PAUSED: 3,
    STOPPED: 4
}

export const CALLING_STATE = {
    NONE: -1,
    INIT: 0,
    PLAY: 1
}
export default class MediaClass {
    constructor (streamUrl, subscriptionModuleId) {
        this.id = 'audio-player-' + subscriptionModuleId
        this.streamUrl = streamUrl
        this.position = 0
        this.timeProgress = '0:0'
        this.timeProgressPercent = 0
        this.status = MEDIA_STATE.NONE
        this.endTime = 'Live',
        this.callingState = CALLING_STATE.NONE
        this.onSuccess = this.onSuccess.bind(this)
        this.onError = this.onError.bind(this)
        this.onStatusChanged = this.onStatusChanged.bind(this)
        this.getCurrentPosition = this.getCurrentPosition.bind(this)
        this.statusCallback = null
        this.showProgressTimer = null

        this.player = new Media(this.streamUrl, this.onSuccess, this.onError, this.onStatusChanged)
    }

    onSuccess () {
        //console.log('Successfully initialized player : ', this.player)
        this.setDuration()
    }

    onError () {
        console.log('Error in player : ', this.player)
    }

    onStatusChanged (status) {
        //console.log('status : ', status)
        this.status = status
        if (this.callingState === CALLING_STATE.INIT && this.status === MEDIA_STATE.RUNNING) {
            //console.log('pause in status', this.callingState, this.status)
            this.callingState = CALLING_STATE.NONE
            this.pause()
            if (this.statusCallback) {
                this.statusCallback(status)
            }
        }
    }

    setCurrentStatus () {
        //console.log('status : ', this.status)
        return this.status
    }

    setDuration () {
        this.duration = this.player.getDuration()
        //console.log('duration', this.duration)
    }

    setProgressPercentage() {
        //console.log('setProgressPercentage')
        let progress
        let defaultDuration = 95
        try {
            progress = (this.timeProgress / this.duration) * 100
        } catch(e) {
            //console.log('progress-percentage', e)
        }
        if (isNaN(progress)) {
            progress = defaultDuration
        }
        this.timeProgressPercent = progress
        //console.log('timeProgressPercent', this.timeProgressPercent)
    }

    startProgressTimer () {
        this.showProgressTimer = setInterval(() => {
            //console.log('startProgressTimer')
            this.setCurrentPosition()
        }, 1000)
    }

    setCurrentPosition () {
        //console.log('setCurrentPosition')
        this.player.getCurrentPosition( this.getCurrentPosition )
    }

    getCurrentPosition (position) {
        //console.log('setCurrentPosition')
        if (position > 0) {
            this.position = position
            //console.log('player position : ', this.position)
            this.setProgressTime()
        }
    }

    setProgressTime () {
        //console.log('setProgressTime position', this.position)
        let currentSeconds = (Math.floor(this.position % 60) < 10 ? '0' : '') + Math.floor(this.position % 60)
        let currentMinutes = Math.floor(this.position / 60)
        let timeProgress = currentMinutes + ':' + currentSeconds
        this.timeProgress = timeProgress
        //console.log('setProgressTime timeProgress', this.timeProgress)
        this.setProgressPercentage()
    }

    stopProgressTimer () {
        if (this.showProgressTimer) {
            clearInterval(this.showProgressTimer)
            //console.log('stopProgressTimer', this.timeProgress)
        }
    }
    
    play () {
        //console.log('play', this.position)
        this.player.play({ playAudioWhenScreenIsLocked : true })
        if (this.callingState !== CALLING_STATE.INIT) {
            this.startProgressTimer()
        }
    }

    pause () {
        //console.log('pause', this.position)
        this.player.pause()
        this.stopProgressTimer()
    }

    stop () {
        this.position = 0
        this.timeProgress = '0:0'
        this.timeProgressPercent = 0
        //console.log('stop', this.position)
        this.player.stop()
        this.stopProgressTimer()
    }
}





// WEBPACK FOOTER //
// ./src/modules/radio-stream/index.js